export function convertToMap(list) {
    var map = new Map();
    list.forEach(function (_a) {
        var key = _a[0], value = _a[1];
        return map.set(key, value);
    });
    return map;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ag-charts-community/dist/es6/util/map.js
// module id = null
// module chunks = 